import { z } from 'zod';
import { utcTimestampSchema, uuidSchema } from './primitives';

/** Files are immutable PNGs; neither IndexedDB nor SQLite contains their bytes. */
export const NOTE_IMAGE_SIZE_LIMIT = 64 * 1024 * 1024;
export const noteImageSchema = z
  .object({
    id: uuidSchema,
    noteId: uuidSchema,
    fileName: z.string(),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    size: z.number().int().nonnegative().max(NOTE_IMAGE_SIZE_LIMIT),
    sha256: z.string().regex(/^[0-9a-f]{64}$/),
    createdAt: utcTimestampSchema,
  })
  .refine((image) => image.fileName === noteImageFileName(image.noteId, image.id), {
    message: '圖片路徑與筆記或圖片 ID 不一致',
    path: ['fileName'],
  });

export type NoteImage = z.infer<typeof noteImageSchema>;

export function noteImageFileName(noteId: string, id: string): string {
  return `images/notes/${noteId}/${id}.png`;
}
